import { ScheduleBuildSettingBase } from './base/schedule-build-setting-base';

export class ScheduleBuildSetting extends ScheduleBuildSettingBase { }